export enum ECOUNTRIES {
  POLAND = 0,
  OTHER = 1,
}
